import { getSearchParams } from '@/utils/url';
import type { apiPatientPortalContract } from '@montugroup/pms-api-contracts';
import type { FieldValues } from 'react-hook-form';
import type { z } from 'zod';

type SubmitTriageFormPostBody = z.infer<typeof apiPatientPortalContract.submitTriageForm.body>;

export const handleTriageAnswersTransform = (formValues: FieldValues): SubmitTriageFormPostBody => {
  const email = getSearchParams('email', { localStorageKey: 'prescreeningUserEmail' })?.trim();

  const { ...values } = formValues;

  const transformed = {
    email: email as string,
    hasMedicare: values.has_medicare,
    hasConcession: values.has_concession_card,
    hasTrialledMedications: values.has_trialled_medication,
    listOfConditions: values.conditions?.concerns?.length
      ? values.conditions.concerns.map((e: { name: string }) => e.name)
      : undefined,
    hasExceededMedicationThreshold: values.current_medication_count
      ? values.current_medication_count === '4+'
      : undefined,
  };

  return { data: transformed };
};
